import { useCallback, useContext, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Dialog, Dialogs, NumericInput, Text } from '@leverege/ui-elements';
import { Attributes, DataSources, EditorUtil } from '@leverege/ui-attributes';
import { ApiProvider } from '@leverege/api-redux';
import { UI } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import MpegTsPlayer from "../player/mpegts/MpegTsPlayer.js";
import S from './VideoStreamRenderer.css';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.attributes.VideoStreamRenderer');
export default function VideoStreamRenderer(props) {
  const {
    context,
    editable,
    variant,
    style,
    value,
    usage,
    object,
    ...options
  } = props;
  const [editing, setEditing] = useState(usage === 'form');
  const vnt = variant ? `videoPlayerPill|${variant}|linkTable` : 'videoPlayerPill|linkTable';
  const onClick = useCallback(() => {
    if (editable) {
      setEditing(true);
    } else {
      Dialogs.show({
        component: VideoStreamDialog,
        props
      });
    }
  }, []);
  if (!editing) {
    return /*#__PURE__*/_jsx(Button, {
      onClick: onClick,
      variant: vnt,
      children: value
    });
  }
  if (!editable) {
    return /*#__PURE__*/_jsx(Text, {
      variant: vnt,
      children: value
    });
  }
  return /*#__PURE__*/_jsx(NumericInput, {
    autoFocus: true,
    style: style // This makes it follow colorizers
    ,
    variant: EditorUtil.getVariant(usage, 'string', 'editor'),
    ...options,
    onDoubleClick: stopProp,
    onBlur: () => {
      if (usage !== 'form') {
        setEditing(false);
      }
    },
    value: value
  });
}
function stopProp(e) {
  if (e.stopPropagation) {
    e.stopPropagation();
  }
}
function VideoStreamDialog({
  show,
  onClose,
  object,
  attribute,
  context: pContext,
  ...rest
}) {
  const api = useContext(ApiProvider.Context);
  const {
    url,
    getAuthHeader,
    delegate
  } = useMemo(() => {
    /**
     * @type {ItemDelegate}
     */
    const delegate = DataSources.getDelegate(object);
    const interfaceUrl = delegate.getInterfaceUrl();
    const url = `${api.host}/${api.child(`v1/interface/${interfaceUrl}.srv/streamProxy/stream`).path()}`;
    return {
      url,
      getAuthHeader: () => api.getToken(),
      delegate
    };
  }, [object, api]);
  const context = useMemo(() => {
    return {
      ...pContext,
      clientProps: {
        ...pContext.clientProps,
        delegate
      }
    };
  }, [pContext, delegate]);
  const name = Attributes.get('name', object);
  return /*#__PURE__*/_jsx(Dialog.Message, {
    className: S.dialog,
    bodyClassName: S.dialogBody,
    variant: "videoStream",
    onClose: onClose,
    show: show,
    title: t('title', {
      source: name,
      blueprintName: attribute.blueprint?.attribute?.blueprint?.name
    }),
    okayVariant: "secondary",
    bodyVariant: "videoStreamBody",
    contentVariant: "videoStreamContent",
    okay: "Close",
    children: /*#__PURE__*/_jsx(MpegTsPlayer, {
      ...rest,
      object: object,
      url: url,
      getAuthHeader: getAuthHeader,
      context: context
    })
  });
}